import { SettlementDetails, WeightedDifference } from 'common/src/utils/types';

export function calculateMarketDifference(
  settlementDetails: SettlementDetails[]
): {
  weightedDiff: WeightedDifference;
  totalKilos: number;
  totalFob: number;
  totalKilosWithDFMarket: number;
  totalFobWithDFMarket: number;
} {
  let weightedDiff: WeightedDifference = {
    byVolume: 0,
    byFob: 0,
  };
  let totalKilos = 0;
  let totalFob = 0;
  let totalKilosWithDFMarket = 0;
  let totalFobWithDFMarket = 0;

  settlementDetails?.forEach((detail) => {
    totalKilos += detail.kilos;
    totalFob += detail.usd_total_fob;
    if (detail.difference_vs_market_eta !== null && detail.difference_vs_market_eta !== undefined && detail.kilos) {
      weightedDiff.byVolume += detail.difference_vs_market_eta * detail.kilos;
      totalKilosWithDFMarket += detail.kilos;
    }
    if (detail.difference_vs_market_eta !== null && detail.difference_vs_market_eta !== undefined && detail.usd_total_fob) {
      weightedDiff.byFob += detail.difference_vs_market_eta * detail.usd_total_fob;
      totalFobWithDFMarket += detail.usd_total_fob;
    }
  });

  return {
    weightedDiff,
    totalKilos,
    totalFob,
    totalKilosWithDFMarket,
    totalFobWithDFMarket,
  };
}
